
import React, { useEffect, useState } from 'react'
import { Button, Modal, Row, Col } from "antd";
import { ReactComponent as SuccessIcon } from '../../../../../assets/images/success.svg';
import { useLazyGetIntroduceDetailQuery } from '../../../../../redux/api/SystemApi'

interface ModalProps {
    visible: boolean;
    onOk: () => void;
}

const ConfirmModal = ({ visible, onOk }: ModalProps) => {
    const [getBankInfo, bankInfo] = useLazyGetIntroduceDetailQuery()
    const [bankContactInfo, setBankContactInfo] = useState<any>()

    useEffect(() => {
        getBankInfo('BANK_CONTACT')
    }, [getBankInfo])

    useEffect(() => {
        if (bankInfo.data) {
            let data = JSON.parse(bankInfo.data.content)
            console.log('data', data.bankName)
            setBankContactInfo(data)
        }
    }, [bankInfo])


    return (
        <Modal
            visible={visible}
            onCancel={onOk}
            style={{ minWidth: 640 }}
            className="custom-modal"
            bodyStyle={{ padding: '60px' }}
            footer={false}
            centered
        >
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
                <SuccessIcon />
            </div>

            <div style={{ textAlign: 'center', fontWeight: 700, marginTop: 30 }}>
                <span className='font-size-16'>Đã gửi yêu cầu tham gia đấu giá thành công! </span>
            </div>

            <div style={{ textAlign: 'center', marginTop: 15 }}>
                <span className='font-size-16'>Bạn cần thanh toán phí đăng ký tham gia đấu giá trong thời
                    gian quy định. Vui lòng thanh toán phí bằng các phương thức sau: <br />
                    <ul>
                        <li>Thực hiện chuyển khoản ngân hàng và nhập thông tin chuyển khoản thành công
                            lên trang web: https://...</li>
                        <li>Thực hiện chuyển khoản và liên hệ trực tiếp với trung tâm đấu giá.</li>
                        <li>Thực hiện nộp tiền mặt tại Trung tâm đấu giá.... (trường hợp số tiền 5.000.000 VNĐ)</li>
                    </ul>
                </span>
            </div>

            <div style={{ textAlign: 'center', fontWeight: 700 }}>
                <span className='font-size-16'>Thông tin chuyển khoản: </span>
            </div>

            <div className='modal-infobox' style={{ marginTop: 15 }}>
                <Row>
                    <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                        <span>Ngân hàng: </span>
                    </Col>
                    <Col span={16} style={{ textAlign: 'left' }}>
                        <span className='font-bold'>{bankContactInfo?.bankName} </span>
                    </Col>
                </Row>
                <Row>
                    <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                        <span>Stk: </span>
                    </Col>
                    <Col span={16} style={{ textAlign: 'left' }}>
                        <span className='font-bold'>{bankContactInfo?.accountNumber} </span>
                    </Col>
                </Row>
                <Row>
                    <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                        <span>Tên người nhận: </span>
                    </Col>
                    <Col span={16} style={{ textAlign: 'left' }}>
                        <span className='font-bold'>{bankContactInfo?.recipient} </span>
                    </Col>
                </Row>
                <Row>
                    <Col span={8} style={{ textAlign: 'right', paddingRight: 15 }}>
                        <span>Nội dung: </span>
                    </Col>
                    <Col span={16} style={{ textAlign: 'left' }}>
                        <span className='font-bold'>{bankContactInfo?.message} </span>
                    </Col>
                </Row>
            </div>

            <div style={{ textAlign: 'center' }}>
                <Button
                    className="button-light-yellow"
                    htmlType='button'
                    type='primary'
                    onClick={onOk}
                    style={{ height: 50, width: 160, fontSize: 16, marginTop: 35 }}
                >
                    ĐỒNG Ý
                </Button>
            </div>
        </Modal>
    )
}

export default ConfirmModal;